/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable no-return-assign */
/* eslint-disable no-return-assign */
/* eslint-disable react/no-danger */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable max-len */
/* eslint-disable react/jsx-indent */
/* eslint-disable react/static-property-placement */
/* eslint-disable semi */
import * as H from 'history'
import React from 'react'
import { Alert } from 'react-bootstrap'
import Button from 'react-bootstrap/Button'
import { ABR_WEBSITE_URL, ASIC_WEBSITE_URL, GRANT_GUIDELINES_URL } from '..'
import { AbnController } from '../../../controllers/AbnController'
import { AbnFetch } from '../../../controllers/AbnFetch'
import { ApplicationController } from '../../../controllers/ApplicationController'
import { ApplicationFetch, OptionItem } from '../../../controllers/ApplicationFetch'
import { DashboardFetch } from '../../../controllers/DashboardFetch'
import { GlobalDataContext, TierItem } from '../../../GlobalDataContext'
import { ApplicationModel } from '../../../models/ApplicationModel'
import { BusinessPartnerModel } from '../../../models/BusinessPartnerModel'
import { CompanyHistoryModel } from '../../../models/CompanyHistoryModel'
import { Consultant } from '../../../models/Consultant'
import { EligibilityValidationModel } from '../../../models/EligibilityValidationModel'
import { FinancialYearModel } from '../../../models/FinancialYearModel'
import { RelatedCompanyModel } from '../../../models/RelatedCompanyModel'
import { TierYearlyLimitEligibilityModel } from '../../../models/TierYearlyLimitEligibilityModel'
import { ISupportSpinner } from '../../../shared/Ajax'
import { Backdrop } from '../../../shared/Backdrop'
import EMDGAccordion from '../../../shared/EMDGAccordion'
import { HttpError } from '../../../shared/FetchBase'
import {
  AbnField, AcnField,
  AnzicField,
  BooleanRadioButtonField,
  Checkbox,
  DateField,
  Label,
  LayoutDisplayEnum,
  MoneyField,
  MultiSelectField,
  NumberField, NumericRadioButtonField,
  NumericSelectField,
  TabHeading,
  TextField,
  TextRadioButtonField,
  validateFields, yesNoDataSource, yesNoPreferNotSayDataSourceEx,
} from '../../../shared/fields'
import { Option } from '../../../shared/fields/Options'
import { Table } from '../../../shared/table'
import {
  ApplicationTiers,
  BusinessCategoriesReform,
  fillExportMarketFinancialsWithDefaults,
  formatDigits,
  get2ndLastFYForDisplay,
  getInvalidFileBlobIds,
  getLastFYForDisplay,
  getMarketCountries,
  isEmpty,
  YesNoPrefer,
} from '../../../shared/Utility'
import { NextBackButtons } from '../../applicationForm-1/controls/NextBackButtons'
import PriorGrants from './Components/PriorGrants'
import { businessPartnerColumns, BusinessPartnerDetails } from './otherTables/businessPartners/BusinessPartnerDetails'
import { companyHistoryColumns, CompanyHistoryDetails } from './otherTables/companyHistory/CompanyHistoryDetails'
import { relatedCompanyColumns, RelatedCompanyDetails } from './otherTables/RelatedCompany/RelatedCompanyDetails'
import { HomeFetch, IServerTimeResponse } from '../../../controllers/HomeFetch'

/* TODO - remove from here, for now remains just in case it needs to be moved to another tab;
export const insolvencyAdministrationDataSource = [
  { value: '498650000', label: 'Insolvency of an individual ' },
  { value: '498650001', label: 'Insolvency of an incorporated body – receiver, administrator, liquidator' },
  { value: '498650002', label: 'Insolvency of incorporated body – controller ' },
  { value: '498650003', label: 'Insolvency of a partnership - partner ' },
  { value: '498650004', label: 'Insolvency of a trust - trustee' },
]
*/

export interface PreviewObj {
    selectedTierDisplayName: string, // includes RepBody
    priorityTradeAreaDisplayName: string,
    // any others as needed
}

export interface EligibleApplicantPageProps {
  history: H.History
  model: ApplicationModel
  onChange: { (changes: Partial<ApplicationModel>, callback?: { (): any }): any }
  addressCountries: Option<string>[]
  consultants: Consultant[]
  preview?: boolean
  currentApplicationPeriod: FinancialYearModel
  markets: Option<string>[]
  marketsKeyOnly: Option<string>[]
  marketRegions: string[]
  previewObj: PreviewObj;
  setPreviewObj?: (updated: Partial<PreviewObj>) => void;
}

export interface EligibleApplicantPageState {
  loading: boolean
  previousInProgressApplication: boolean
  activeGrantAgreement: boolean
  anySubmittedApplicationExistsForAbn: boolean
  selectedTierValue : string, // local state to manage tier-radio-button group (includes RepBody)
  tierErrorMessage: string
  tierSelectionIsValid: boolean // includes RepBody, refers to the buttons as a whole
  tierSelectionInternalName: string // RepBody, Tier1, Tier2, Tier3
  filteredMarkets: Option<string>[],
  repBodyMarketsNotApplicable: boolean,
  isEligibleAsPerTierYearlyLimit?: boolean
  priorityTradeAreaDataSource: OptionItem[]
  annualTurnoverEligibility: EligibilityValidationModel
  grantHistoryEligibility: EligibilityValidationModel
  yearsInBusinessEligibility: EligibilityValidationModel
}

const TIER_ERROR_OPEN_IN_FUTURE = 'You are not able to submit an application for this tier category as it is not open to accept applications at this stage. For information on when the tier category will open please visit <a href="https://www.austrade.gov.au/emdg" target="_blank">www.austrade.gov.au/emdg</a>';

const TIER_ERROR_CLOSED_ALREADY = 'You are no longer able to submit an application for this tier category as funding has been exhausted.';

export class EligibleApplicantPage extends React.Component<EligibleApplicantPageProps, EligibleApplicantPageState> implements ISupportSpinner {
  static contextType = GlobalDataContext
  context!: React.ContextType<typeof GlobalDataContext>

  termsAndConditions: Checkbox;
  privacy: Checkbox;
  sharingInformation: Checkbox;
  acceptFeedbackAgreement: Checkbox;
  abn: TextField
  acn: TextField
  enoughFundsForExpenditure: BooleanRadioButtonField
  registeredBusinessName: TextField
  anzsicCode: AnzicField
  priorityTradeArea: NumericRadioButtonField
  tradingName: TextField
  hasBusinessNameChanged: BooleanRadioButtonField
  dateBusinessNameChanged: DateField
  previousBusinessName: TextField
  businessCategory: NumericSelectField
  insolvencyAdministrationType: TextRadioButtonField
  dateOperationsCommenced: DateField
  totalEmployees: NumberField
  totalEmployeesOverseas: NumberField
  totalTurnover: MoneyField
  relatedCompanies: Table<RelatedCompanyModel>
  invalidBusinessCategoryError: HTMLDivElement
  // postalAddressDifferent: BooleanRadioButtonField
  // haveReceivedGrant: BooleanRadioButtonField
  isInsolvent: BooleanRadioButtonField
  isConvictedDisqualified: BooleanRadioButtonField
  acceptATOComplianceDeclaration: BooleanRadioButtonField
  partOfRelatedGroup: BooleanRadioButtonField
  hasCompanyHistory: BooleanRadioButtonField
  directorInBusinessPreviouslyAppliedForGrant: BooleanRadioButtonField
  isIndiginousOwned: NumericRadioButtonField
  isIndiginousControlled: NumericRadioButtonField
  businessPartners: Table<BusinessPartnerModel>
  companyHistories: Table<CompanyHistoryModel>
  ajax: ApplicationController
  abnAjax: AbnController
  directorCompanyName: TextField
  directorABN: AbnField
  abnError: HTMLDivElement
  tierYearlyLimitEligibilityError: HTMLDivElement
  annualTurnoverEligibilityError: HTMLDivElement
  grantHistoryEligibilityError: HTMLDivElement
  yearsInBusinessEligibilityError: HTMLDivElement
  insolvenyError: HTMLDivElement
  convictedDisqualificationError: HTMLDivElement
  ATOComplianceDeclarationError: HTMLDivElement

  exportMarkets: MultiSelectField<string>
  dashboardFetch = new DashboardFetch();
  homeFetch = new HomeFetch();
  applicationFetch = new ApplicationFetch();
  abnFetch = new AbnFetch();

  constructor(props: EligibleApplicantPageProps) {
    super(props)
    // const { model } = this.props
    this.ajax = new ApplicationController()
    this.abnAjax = new AbnController()

    const { markets, marketRegions } = props;
    const filteredMarkets = getMarketCountries(markets, marketRegions) // default: countries only;

    this.state = {
      loading: false,
      previousInProgressApplication: false,
      activeGrantAgreement: false,
      anySubmittedApplicationExistsForAbn: false,
      selectedTierValue: null, // local state for radio-buttons
      tierErrorMessage: '',
      tierSelectionIsValid: false,
      tierSelectionInternalName: '',
      filteredMarkets,
      repBodyMarketsNotApplicable: false,
      isEligibleAsPerTierYearlyLimit: null,
      priorityTradeAreaDataSource: [],
      annualTurnoverEligibility: null,
      grantHistoryEligibility: null,
      yearsInBusinessEligibility: null,
    }
  }

  componentDidMount() {
    const { model } = this.props;

    this.applicationFetch.fetchPriorityTradeAreas()
      .then((data: OptionItem[]) => {
        this.setState({ priorityTradeAreaDataSource: data });
      })
      .catch((error) => {
        console.error('Error fetching priority trade areas:', error);
      });

    const notApplicable = model.marketsCodes.includes('00000000-0000-0000-0000-000000000000');
    this.setState({
      repBodyMarketsNotApplicable: notApplicable,
    })

    // Restore previous selections, only if it has been previously set
    let mockEvent;
    if (model.isPeakIndustryBody && model.applicationTier === null) {
      mockEvent = {
        target: {
          value: '0',
        },
      } as React.ChangeEvent<HTMLInputElement>;
    } else if (!model.isPeakIndustryBody && model.applicationTier) {
      mockEvent = {
        target: {
          value: model.applicationTier,
        },
      } as React.ChangeEvent<HTMLInputElement>;
    } else return;

    // Call the handler with the mock event so that the rendering below the tier-settings radio button works correctly.
    this.tierSelection_ChangeHandler(mockEvent, true)
  }

  componentDidUpdate(prevProps: EligibleApplicantPageProps, prevState: EligibleApplicantPageState) {
    const { model, onChange } = this.props

    // Q.28 checkbox should be rendered
    const shouldRenderCheckbox = model.isIndiginousOwned === YesNoPrefer.Yes || model.isIndiginousControlled === YesNoPrefer.Yes;
    // Q.28 was previously rendered
    const wasCheckboxRendered = prevProps.model.isIndiginousOwned === YesNoPrefer.Yes || prevProps.model.isIndiginousControlled === YesNoPrefer.Yes;

    if (!shouldRenderCheckbox && wasCheckboxRendered) {
      // set to null in DB whenever not rendered;
      if (model.hasConsentedToShareFirstNationsStatus !== null) {
        onChange({ hasConsentedToShareFirstNationsStatus: null });
      }
    } else if (shouldRenderCheckbox && !wasCheckboxRendered) {
      // if rendered set to false in DB
      if (model.hasConsentedToShareFirstNationsStatus === null) {
        onChange({ hasConsentedToShareFirstNationsStatus: false });
      }
    }

    if (model.abn !== prevProps.model.abn) {
      this.ajax.prepopulate(this, model, (d) => {
        if (d) {
          onChange(d, () => this.onDateOperationsCommencedChange())
        } else {
          onChange({
            registeredBusinessName: '',
            tradingName: '',
            // acn: ''
          })
        }
      })
    }

    // Bug 152340
    if (!this.props.model.isConsultant && prevState.selectedTierValue !== this.state.selectedTierValue) {
      this.onDateOperationsCommencedChange()
    }

    /* TODO: below appears to be wrong, and no longer relevant ! remove after a few Testing iterations!
    if (model.isPeakIndustryBody !== prevProps.model.isPeakIndustryBody) {
      onChange({
        haveExportPlan: null,
        hasEverExported: null,
        haveReceivedGrant: null,
        hasExportReadiness: null,
        dateOfMostRecentExport: null,
        expenseAreExpandingExportPromotion: null,
        expenseEligibleExpensesTraining: null,
        expenseEligibleExpensesNotMet: null,
        expenseDescribeTraining: null,
        applicationTier: null,
        marketsCodes: [],
      })
    }
    */
    // If any change to selection of Tiers (or Rep Body) reset all fields in Eligible Tier tab
    if ((model.applicationTier !== prevProps.model.applicationTier) || (model.isPeakIndustryBody !== prevProps.model.isPeakIndustryBody)) {
      this.resetFields(model.isPeakIndustryBody, model.applicationTier)
    }

    if (model.haveYourBusinessPartnersEverAppliedEMDG !== prevProps.model.haveYourBusinessPartnersEverAppliedEMDG
          && !model.haveYourBusinessPartnersEverAppliedEMDG) {
      onChange({
        directorABN: null,
        directorCompanyName: null,
      })
    }

    // calculate local state since its not persisted
    if (this.state.tierSelectionInternalName !== prevState.tierSelectionInternalName) {
      const notApplicable = model.marketsCodes.includes('00000000-0000-0000-0000-000000000000');
      this.setState({
        repBodyMarketsNotApplicable: notApplicable,
      })
    }

    // workaround for Print/Preview Q1.
    if (this.state.selectedTierValue !== prevState.selectedTierValue) {
      const selectedTierDisplayName = this.context.tierSettingsArr.find((item) => item.tierValue.toString() === this.state.selectedTierValue)?.displayName || '--'
      this.props.setPreviewObj(
        {
          selectedTierDisplayName,
        },
      );
    }

    // workaround for Print/Preview Q11.
    if (model.priorityTradeArea !== prevProps.model.priorityTradeArea || (this.state.priorityTradeAreaDataSource !== prevState.priorityTradeAreaDataSource)) {
      const priorityTradeAreaDisplayName = this.state.priorityTradeAreaDataSource.find((item) => item.value === model.priorityTradeArea)?.label || '--'
      this.props.setPreviewObj(
        {
          priorityTradeAreaDisplayName,
        },
      );
    }
  }

  componentWillUnmount() {
    this.ajax.cancel()
  }

  resetFields = (isRepBody: boolean, tier:string) => {
    const { onChange } = this.props

    onChange({
      // Eligible Applicant Tab Fields
      marketsCodes: [],
      hasCompanyHistory: null,
      companyHistories: [],

      // Eligibiliy Tier Tab Fields
      // tier 1 fields
      hasEverExported: null,
      hasExportReadiness: null,
      marketingSkillsInForeignCountry: null,
      exportReadinessEvidence: null,
      exportReadinessTrainingCourseDate: null,
      completedExpoReadinessTestFromAustrade: null,
      hasDesignatedConnectionToEligibleProducts: null,
      designatedConnectionToEligibleProducts: null,
      // tier 2 fields
      dateOfMostRecentExport: null,
      expenseAreExpandingExportPromotion: null,
      exportMarketFinancials: [],
      financialYearOfExportEarnings: null,
      exportEarningsForFY: null,
      // tier 3 fields
      isStrategicShift: null,
      typeOfStrategicShift: null,
      // repbody fields
      expenseEligibleExpensesTraining: null,
      expenseEligibleExpensesNotMet: null,
      doPromoteAustralianBusinessInterests: null,
      describePromoteAustralianBusinessInterests: null,
      doRepresentSmeMembersInIndustry: null,
      describeRepresentSmeMembersInIndustry: null,
      areSmeMembersRepresentProportionOfBusiness: null,
      describeSmeMembersRepresentProportionOfBusiness: null,
      doDistributeIncomeToSmeMembers: null,
      describeNotForProfitBusinessStructure: null,
      areSmeMembersExportingOrReadyToExport: null,
      describeSmeMembersExportingOrReadyToExport: null,
      doExportEligibleProductsAsPrimaryActivity: null,
      describeExportEligibleProductsAsPrimaryActivity: null,
    })

    if (isRepBody) {
      onChange({
        expenseEligibleExpensesTraining: false,
        expenseEligibleExpensesNotMet: false,
      })
    }
    if (tier === ApplicationTiers.Tier1) {
      onChange({
        exportReadinessEvidence: false,
        completedExpoReadinessTestFromAustrade: false,
      })
    }
  }

  savePriorToNewRoute = async () => {
    const { model, onChange } = this.props
    const invalidDocuments = getInvalidFileBlobIds(model)

    // don't save partially completed rows in table
    const finArray = [...model.exportMarketFinancials]
    const fullRowsOnly = finArray.filter((row) => {
      if (row.crmExportMarketID && row.earnings && row.crmExportMarketID.length >= 32 && !Number.isNaN(row.earnings)) {
        return true;
      }
      return false;
    })

    const newModel = JSON.parse(JSON.stringify(model))
    newModel.exportMarketFinancials = fullRowsOnly;
    const updatedModel = { ...newModel, invalidDocuments }
    return new Promise<void>((resolve) => {
      this.ajax.updateApplication(
        this,
        updatedModel,
        (d) => {
          onChange({ ...model, ...d });
          resolve();
        },
      );
    });
  }

  next = async () => {
    const { loading } = this.state
    if (loading) {
      return
    }

    const {
      model, model: {
        abn, financialYearName, isPeakIndustryBody, applicationTier,
      },
    } = this.props

    if (this.totalEmployees.state.errorMessage) {
      this.totalEmployees.focus()
      return
    }

    if (this.totalEmployeesOverseas.state.errorMessage) {
      this.totalEmployeesOverseas.focus()
      return
    }

    validateFields(
      async (res) => {
        if (res) {
          const anySubmittedApplicationExistsForAbn = await this.anySubmittedApplicationExistsForAbn(abn, financialYearName)
          const isEligibleAsPerTierYearlyLimit = await this.validateTierYearlyLimitEligibility(abn, financialYearName, isPeakIndustryBody, applicationTier);
          const annualTurnoverEligibility = await this.validateAnnualTurnoverEligibility();
          const grantHistoryEligibility = await this.validateGrantHistoryEligibility(abn);
          const yearsInBusinessEligibility = await this.validateYearsInBusinessEligibility();
          this.setState({
            anySubmittedApplicationExistsForAbn, isEligibleAsPerTierYearlyLimit, annualTurnoverEligibility, grantHistoryEligibility, yearsInBusinessEligibility,
          }, () => {
            if (!annualTurnoverEligibility.isEligible) {
              this.annualTurnoverEligibilityError.focus()
              return
            }
            if (!grantHistoryEligibility.isEligible) {
              this.grantHistoryEligibilityError.focus()
              return
            }
            if (!yearsInBusinessEligibility.isEligible) {
              this.yearsInBusinessEligibilityError.focus()
              return
            }
            if (this.handleActiveGrantAgreement()) {
              return
            }
            if (this.handleSubmittedApplicationExistsForAbn()) {
              return
            }
            if (this.handleTierYearlyLimitEligibilty()) {
              return
            }
            if (!this.isValidBusinessCategory()) {
              this.invalidBusinessCategoryError.focus()
              return
            }
            if (!this.isInsolvencyEligible()) {
              return
            }
            if (!this.isConvictedDisqualificationEligible()) {
              return
            }
            if (!this.isATOComplianceDeclarationEligible()) {
              return
            }

            const { history, onChange } = this.props
            let exportMarketFinancials = [...model.exportMarketFinancials]
            if (exportMarketFinancials && exportMarketFinancials.length > 0) {
              exportMarketFinancials = fillExportMarketFinancialsWithDefaults(exportMarketFinancials)
            }
            const invalidDocuments = getInvalidFileBlobIds(model)
            const updatedModel = { ...JSON.parse(JSON.stringify(model)), invalidDocuments, exportMarketFinancials }

            this.ajax.updateApplication(
              this,
              updatedModel,
              async (d) => {
                onChange({ ...model, ...d })
                // run tier validations again on saveNext btn: user-story #143095
                // Reset the validation state, prior to re-running validation logic
                this.setState({ tierSelectionIsValid: false }, async () => {
                  // simulate tier selection validation, with a mock event.
                  const mockEvent = { target: { value: this.state.selectedTierValue } } as React.ChangeEvent<HTMLInputElement>;
                  await this.tierSelection_ChangeHandler(mockEvent, true);

                  // Only navigate to next page if validation passes
                  if (this.state.tierSelectionIsValid) {
                    history.push(`/reform/${model.applicationID}/eligibletiers`)
                  }
                });
              },
            )
          })
        }
      },
      this.termsAndConditions,
      this.privacy,
      this.sharingInformation,
      this.acceptFeedbackAgreement,
      this.abn,
      this.businessCategory,
      this.acn,
      this.registeredBusinessName,
      this.anzsicCode,
      this.priorityTradeArea,
      this.tradingName,
      this.hasBusinessNameChanged,
      this.dateBusinessNameChanged,
      this.previousBusinessName,
      this.dateOperationsCommenced,
      this.totalEmployees,
      this.totalEmployeesOverseas,
      this.totalTurnover,
      this.isInsolvent,
      this.insolvencyAdministrationType,
      this.isConvictedDisqualified,
      this.acceptATOComplianceDeclaration,
      this.partOfRelatedGroup,
      this.relatedCompanies,
      this.hasCompanyHistory,
      this.companyHistories,
      this.businessPartners,
      this.directorInBusinessPreviouslyAppliedForGrant,
      this.directorCompanyName,
      this.directorABN,
      this.isIndiginousOwned,
      this.isIndiginousControlled,
      this.enoughFundsForExpenditure,
      this.exportMarkets,
    )
  }

  toggleSpinner(on: boolean, callback: { (): any }): void {
    this.setState({ loading: on }, callback)
  }

  // #region Validation

  // #region Handle Annual Turnover change and eligibility validation

  async onTotalTurnoverChange() {
    const annualTurnoverEligibility = await this.validateAnnualTurnoverEligibility();

    this.setState({ annualTurnoverEligibility })
  }

  async validateAnnualTurnoverEligibility(): Promise<EligibilityValidationModel> {
    const { model } = this.props

    if (model.totalTurnover === null || model.isPeakIndustryBody || model.applicationTier === null) { // TODO: Check return
      return { isEligible: true, displayErrorMessage: '' }
    }

    return new Promise((resolve: (res: EligibilityValidationModel) => void) => {
      this.ajax.validateAnnualTurnoverEligibility(this, {
        totalTurnover: model.totalTurnover, grantProgramRound: model.financialYearName, isRepresentativeBody: false, appTier: model.applicationTier,
      }, (res: EligibilityValidationModel) => {
        resolve(res)
      })
    })
  }

  // #endregion Handle Annual Turnover change and eligibility validation

  // #region Handle Grant History eligibility validation

  async validateGrantHistoryEligibility(abn: string): Promise<EligibilityValidationModel> {
    const { model: { isPeakIndustryBody } } = this.props

    if (abn === null || isPeakIndustryBody) { // TODO: Check return
      return { isEligible: true, displayErrorMessage: '' }
    }

    return new Promise((resolve: (res: EligibilityValidationModel) => void) => {
      this.ajax.validateGrantHistoryEligibility(this, { abn }, (res: EligibilityValidationModel) => {
        resolve(res)
      })
    })
  }

  // #endregion Handle Grant History eligibility validation

  // #region Handle ABN change and validation

  handleActiveGrantAgreement = (): boolean => {
    const { activeGrantAgreement } = this.state

    if (activeGrantAgreement) {
      this.abnError.focus()
    }

    return !!activeGrantAgreement
  }

  handleSubmittedApplicationExistsForAbn = (): boolean => {
    const { anySubmittedApplicationExistsForAbn } = this.state

    if (anySubmittedApplicationExistsForAbn) {
      this.abnError.focus()
    }

    return !!anySubmittedApplicationExistsForAbn
  }

  anySubmittedApplicationExistsForAbn = async (abn: string, financialYearName: string) => {
    if (isEmpty(abn) || isEmpty(financialYearName)) {
      return false
    }
    return new Promise((resolve: (value: boolean) => void) => {
      this.abnAjax.anySubmittedApplicationExistsForAbn(this, abn, financialYearName, (res) => {
        resolve(res)
      })
    })
  }

  async ABN_LostFocus(abn: string, isAbnFormatValid: boolean): Promise<void> {
    const { onChange, model: { financialYearName } } = this.props

    let existInABR: boolean = false;
    if (isAbnFormatValid) {
      try {
        const abnDetails = await this.abnFetch.getByAbn(abn);
        existInABR = abnDetails !== null && abnDetails.abn === abn;
      } catch (err) {
        console.error('ABN fetch error', err);
      }
    }

    const applicationExistsForAbn = async (abn: string) => new Promise((resolve: (value: boolean) => void) => {
      this.abnAjax.isApplicationExistsForAbn(this, abn, financialYearName, (previousInProgressApplication) => {
        resolve(previousInProgressApplication)
      })
    })

    const anySubmittedApplicationExistsForAbnFunction = async (abn: string) => new Promise((resolve: (value: boolean) => void) => {
      this.abnAjax.anySubmittedApplicationExistsForAbn(this, abn, financialYearName, (anySubmittedApplicationExistsForAbn) => {
        resolve(anySubmittedApplicationExistsForAbn)
      })
    })

    const hasActiveGrantAgreement = async (abn: string) => new Promise((resolve: (value: boolean) => void) => {
      this.ajax.isActiveGrantAgreement(this, abn, (activeGrantAgreement) => {
        resolve(activeGrantAgreement)
      })
    })

    if (existInABR) {
      // changed to ensure ABN is valid against the ABR, before attempting other checks;
      this.setState({
        activeGrantAgreement: await hasActiveGrantAgreement(abn),
        previousInProgressApplication: await applicationExistsForAbn(abn),
        anySubmittedApplicationExistsForAbn: await anySubmittedApplicationExistsForAbnFunction(abn),
        grantHistoryEligibility: await this.validateGrantHistoryEligibility(abn),
      })
    } else {
      // ABN Not valid - clear any dependent fields
      this.setState({
        activeGrantAgreement: false,
        previousInProgressApplication: false,
        anySubmittedApplicationExistsForAbn: false,
      });
    }
    if (!this.props.model.isConsultant) {
      this.setState({ yearsInBusinessEligibility: null })
    }
    // Always call with ABN current value, even if not valid
    onChange({ abn })
  }

  // #endregion Handle ABN change and validation

  // #region Handle Tier change and validation

  validateTierYearlyLimitEligibility = async (abn: string, financialYearName: string, isRepresentativeBody:boolean, applicationTier: string) => {
    // If mandatory fields do not exist, return null and leave it to mandatory validation to catch errors
    if (isEmpty(abn) || isEmpty(financialYearName) || (!isRepresentativeBody && !applicationTier)) {
      return null
    }
    // validate yearly limit eligibility
    return new Promise((resolve: (isEligible: boolean) => void) => {
      this.ajax.validateTierYearlyLimitEligibility(this, {
        abn,
        financialYearName,
        isRepresentativeBody,
        appTier: parseInt(applicationTier, 10),
      }, (res: TierYearlyLimitEligibilityModel) => {
        resolve(res.isEligible)
      })
    })
  }

  handleTierYearlyLimitEligibilty = (): boolean => {
    const { isEligibleAsPerTierYearlyLimit } = this.state

    if (isEligibleAsPerTierYearlyLimit === false) {
      this.tierYearlyLimitEligibilityError.focus()
      return true;
    }
    return false;
  }

  // eslint-disable-next-line class-methods-use-this
  tierSelection_ChangeHandler = async (event: React.ChangeEvent<HTMLInputElement>, isMockEvent:boolean = false): Promise<void> => {
    const selectedTierValue = event.target.value;
    /* we could use context data, but it may be stale, we want latest as of now.
    const tierDataCtx = this.context;
    const selectedItem = tierDataCtx.tierSettingsArr.find(item => item.tierValue.toString() === selectedTierValue); */

    // do validations to determine what gets rendered after the Tier-settings radio button;

    try {
      const tierSettingsArr: TierItem[] = await this.dashboardFetch.retrieveTierSettings();

      const selectedItem = tierSettingsArr.find((item) => item.tierValue.toString() === selectedTierValue);
      if (!selectedItem) {
        alert('Tier settings data is inconsistent. Cannot continue')
        return;
      }

      let marketsDataSource;
      const { markets, marketRegions, marketsKeyOnly } = this.props;
      if (selectedItem.internalName === 'Tier3') {
        marketsDataSource = marketsKeyOnly;
      } else {
        marketsDataSource = getMarketCountries(markets, marketRegions);
      }

      this.setState({
        tierSelectionInternalName: selectedItem.internalName,
        selectedTierValue,
        filteredMarkets: marketsDataSource,
        annualTurnoverEligibility: null,
      });

      const { onChange, model } = this.props;
      onChange({
        ...model,
        applicationTier: selectedItem.tierValue === 0 ? null : selectedItem.tierValue.toString(),
        isPeakIndustryBody: selectedItem.isRepBody,
      });

      if (!this.props.model.isConsultant) {
        this.setState({ yearsInBusinessEligibility: null })
      }

      // validations to determine what gets rendered below radio buttons......
      const currentDate = new Date();

      // it is possible dates are not set in CRM!
      if (!selectedItem.openingDateUTC || !selectedItem.closingDateUTC) {
        this.setState({ tierErrorMessage: 'Opening / Closing dates are not defined correctly for this tier !' });
        return;
      }
      // Convert the opening and closing dates to Date objects
      const openingDate = new Date(selectedItem.openingDateUTC);
      const closingDate = new Date(selectedItem.closingDateUTC);

      // Perform validation
      if (currentDate < openingDate) {
        // If current_date is before "openingDate", show error message A
        await new Promise<void>((resolve) => {
          this.setState({ tierErrorMessage: TIER_ERROR_OPEN_IN_FUTURE, tierSelectionIsValid: false }, resolve);
        });
      } else if (currentDate >= closingDate) {
        // If current_date is on or after "closingDate", show error message B
        await new Promise<void>((resolve) => {
          this.setState({ tierErrorMessage: TIER_ERROR_CLOSED_ALREADY, tierSelectionIsValid: false }, resolve);
        })
      } else {
        // If current_date falls within both "openingDate" and "closingDate", then don't show error
        await new Promise<void>((resolve) => {
          this.setState({ tierErrorMessage: null, tierSelectionIsValid: true }, resolve);
        })
      }

      if (!model.isConsultant) {
        const grantHistoryEligibility = await this.validateGrantHistoryEligibility(model.abn);
        this.setState({ grantHistoryEligibility })

        const anySubmittedApplicationExistsForAbn = await this.anySubmittedApplicationExistsForAbn(model.abn, model.financialYearName)
        this.setState({ anySubmittedApplicationExistsForAbn })
      }

      // reset on Tier change, but only if user interacts directly with Button controls, i.e. not during initial load
      if (!isMockEvent) {
        this.setState({
          repBodyMarketsNotApplicable: false,
        });
        onChange({ marketsCodes: [] });
      }
    } catch (error) {
      if (error instanceof HttpError) {
        // Handle HttpError here
        console.error(`HTTP error occurred: ${error.status}`);
      } else {
        // Handle any other errors here
        console.error(error);
      }
    }
  };

  // #endregion Handle Tier change and validation

  // #region Handle DateOperationsCommenced change and min years in operation eligibility validation

  async onDateOperationsCommencedChange() {
    const yearsInBusinessEligibility = await this.validateYearsInBusinessEligibility()

    this.setState({ yearsInBusinessEligibility })

    if (!yearsInBusinessEligibility.isEligible) {
      this.yearsInBusinessEligibilityError?.focus()
    }
  }

  async validateYearsInBusinessEligibility(): Promise<EligibilityValidationModel> {
    const { model } = this.props

    if (model.dateOperationsCommenced === null || model.isPeakIndustryBody || model.applicationTier === null) { // TODO: Check return
      return { isEligible: true, displayErrorMessage: '' }
    }

    return new Promise(async (resolve: (res: EligibilityValidationModel) => void) => {
      const res = await this.applicationFetch.validateYearsInBusinessEligibility(model.dateOperationsCommenced, model.financialYearName, false, this.state.selectedTierValue)
      resolve(res)
    })
  }

  // #endregion Handle DateOperationsCommenced change and min years in operation eligibility validation

  isInsolvencyEligible = (): boolean => {
    const { model } = this.props

    if (model.isInsolvent && !model.isPeakIndustryBody) {
      this.insolvenyError.focus()
      return false;
    }

    return true;
  }

  isConvictedDisqualificationEligible = (): boolean => {
    const { model } = this.props

    if (model.isConvictedDisqualified) {
      this.convictedDisqualificationError.focus()
      return false;
    }

    return true;
  }

  isATOComplianceDeclarationEligible = (): boolean => {
    const { model } = this.props

    if (!model.acceptATOComplianceDeclaration) {
      this.ATOComplianceDeclarationError.focus()
      return false;
    }

    return true;
  }

  isValidBusinessCategory(): boolean {
    const { model } = this.props
    const entityTypesCategoryMapping = [
      { category: BusinessCategoriesReform.Individual, entityTypes: ['Individual/Sole Trader'] },
      // { category: BusinessCategoriesReform.CoOperative, entityTypes: ['Co-operative', 'Commonwealth Government Co-operative', 'Local Government Co-operative'] },
      { category: BusinessCategoriesReform.Partnership, entityTypes: ['Family Partnership', 'Limited Partnership', 'Other Partnership', 'Commonwealth Government Partnership'] },
      {
        category: BusinessCategoriesReform.Company,
        entityTypes: [
          'Australian Private Company',
          'Australian Public Company',
          'Commonwealth Government Company',
          'Commonwealth Government Private Company',
          'Commonwealth Government Public Company',
          'Local Government Company',
          'Local Government Private Company',
          'Local Government Public Company',
          'State Government Company',
          'State Government Private Company',
          'State Government Public Company',
        ],
      },
      // {
      //   category: BusinessCategoriesReform.BodyCorp,
      //   entityTypes: [
      //     'Other Incorporated entity',
      //     'Other Unincorporated Entity',
      //     'Commonwealth Government Entity',
      //     'Commonwealth Government Other Incorporated Entity',
      //     'Local Government Entity',
      //     'Local Government Other Incorporated Entity',
      //     'State Government Entity',
      //     'State Government Other Incorporated Entity',
      //     'Territory Government Entity',
      //     'Territory Government Other Incorporated Entity',
      //   ],
      // },
      {
        category: BusinessCategoriesReform.Trust,
        entityTypes: [
          'Corporate Unit Trust',
          'Deceased Estate',
          'Discretionary Investment Trust',
          'Discretionary Services Management Trust',
          'Discretionary Trading Trust',
          'Fixed Trust',
          'Fixed Unit Trust',
          'Hybrid Trust',
          'Listed Public Unit Trust',
          'Other Trust',
          'Public Trading Trust',
          'Unlisted Public Unit Trust',
        ],
      },
    ]

    if (model.businessCategory && model.entityTypeLabel) {
      const validEntityTypes = entityTypesCategoryMapping.filter((m) => m.category === model.businessCategory)
      if (validEntityTypes.length > 0) {
        const entityType = model.entityTypeLabel.toUpperCase()
        for (const e of validEntityTypes[0].entityTypes) {
          if (e.toUpperCase() === entityType) {
            return true
          }
        }
        return false
      }
    }

    return true
  }

  // #endregion Validation

  repBodyMarketsNotApplicable_CheckboxHandler = (event) => {
    // eslint-disable-next-line prefer-destructuring
    const checked = event.target.checked;
    this.setState({
      repBodyMarketsNotApplicable: checked,
    });
    const newMarketsCodes = checked ? ['00000000-0000-0000-0000-000000000000'] : [];
    this.props.onChange({ marketsCodes: newMarketsCodes });
  };

  render() {
    const { selectedTierValue, repBodyMarketsNotApplicable } = this.state;

    const businessCategories = [
      { value: BusinessCategoriesReform.Individual, label: 'an Australian individual whose principal place of residence is in Australia' },
      { value: BusinessCategoriesReform.Company, label: 'a body incorporated under the Corporations Act 2001' },
      { value: BusinessCategoriesReform.CoOperative, label: 'an association, or cooperative, incorporated under an Australian law' },
      { value: BusinessCategoriesReform.Partnership, label: 'a partnership that is formed and operated under a law of a State or Territory and at least half the partners are Australian persons' },
      { value: BusinessCategoriesReform.Trust, label: 'a trust that is Australian within the meaning of the EMDG Rules, that is the trustee, or each trustee, of the trust is an Australian person' },
      { value: BusinessCategoriesReform.BodyCorp, label: 'a body corporate established for a public purpose by or under an Australian law' },
    ]

    const submittedApplicationExistsForAbnErrorMessage = 'An application has already been submitted for the specified ABN for this grant year. Application cannot be submitted.';

    const {
      onChange,
      // consultants, MOVE TO DIFFERENT TAB
      history, addressCountries, model, preview,
    } = this.props

    const {
      loading, previousInProgressApplication, activeGrantAgreement,
      anySubmittedApplicationExistsForAbn,
      tierSelectionInternalName,
      isEligibleAsPerTierYearlyLimit,
      annualTurnoverEligibility,
      grantHistoryEligibility,
      yearsInBusinessEligibility,
    } = this.state

    const showTierSelectionSelection = (model.termsAndConditions && model.privacy);
    const showTierSelectedQuestions = showTierSelectionSelection
              && ((!preview && this.state.tierSelectionIsValid) || (preview && (model.isPeakIndustryBody || model.applicationTier)));
    const showApplicationBusinessDetails = showTierSelectedQuestions && (model.isPeakIndustryBody || model.enoughFundsForExpenditure);
    const showApplicationBusinessStructure = showTierSelectedQuestions && (model.isPeakIndustryBody || model.enoughFundsForExpenditure);

    const showBusinessDirectory = (model.businessCategory === BusinessCategoriesReform.Company
      || model.businessCategory === BusinessCategoriesReform.Partnership
      || (model.businessCategory === BusinessCategoriesReform.Trust))

    const showACN = (
      (model.businessCategory === BusinessCategoriesReform.Company
        || model.businessCategory === BusinessCategoriesReform.CoOperative
        || model.businessCategory === BusinessCategoriesReform.BodyCorp)
     && !!model.acn.replace(/\s+/g, '')) || model.businessCategory === BusinessCategoriesReform.Trust

    const directorABN = model.directorABN ? model.directorABN.trim() : ''

    const tierDataCtx = this.context

    // Sort the data by sortOrder
    const sortedData = tierDataCtx.tierSettingsArr.sort((a, b) => a.sortOrder - b.sortOrder)
    return (
      <>
        <TabHeading
          label="Eligible applicant"
          preview={preview}
        />
        <Alert className="emdg-page-alerts">
          Please ensure that you check and answer all questions and provide supporting documentation before submitting your application online.
          We will not accept late or incomplete applications.
          <br />
          <br />
          You must complete every page and click on the Submit button to lodge your application.
          You will receive an email with your application ID acknowledging that your application has been received by Austrade.
        </Alert>

        <h4>Terms and conditions of use</h4>
        <span>You are required to read and agree to the terms and conditions prior to completing and submitting your application.</span>
        <div className="form-item">
          <Checkbox
            ref={(r) => { this.termsAndConditions = r }}
            id="termsAndConditions"
            required
            requiredMessage="You must accept terms and conditions"
            onChange={(val) => onChange({ termsAndConditions: val || null })}
            value={model.termsAndConditions}
            label={(
              <span>
                {'I have read and accept the '}
                <a href="https://www.austrade.gov.au/en/site-information/emdg-online-portal-terms-and-conditions" target="_blank" rel="noreferrer">terms and conditions of use</a>
                .
              </span>
            )}
            preview={preview}
          />
        </div>

        <h4>Confidentiality and privacy</h4>
        You must read and agree to the confidentiality and privacy statement prior to completing and submitting your application. It provides information on how we handle your data and information. Opting out in this section does not prevent Austrade from sharing specific information allowable in the Austrade Act 1985 or using the information internally for trade facilitation.
        <div className="form-item">
          <Checkbox
            ref={(r) => { this.privacy = r }}
            id="privacy"
            required
            requiredMessage="You must accept confidentiality & privacy"
            onChange={(val) => onChange({ privacy: val || null })}
            value={model.privacy}
            label={(
              <span>
                {'I have read and accept the '}
                <a href="https://www.austrade.gov.au/en/site-information/emdg-online-portal-privacy-and-confidentiality" target="_blank" rel="noreferrer">confidentiality and privacy</a>
                {' '}
                provisions.
              </span>
            )}
            preview={preview}
          />
        </div>

        <h4>Additional information sharing</h4>
        Please confirm if you agree to Austrade sharing your contact details with other government organisations that provide trade facilitation and business assistance services.
        <div className="form-item">
          <Checkbox
            ref={(r) => { this.sharingInformation = r }}
            id="shareInformation"
            required={false}
            onChange={(val) => onChange({ sharingInformation: val || null })}
            value={model.sharingInformation}
            label={<span>I agree that my contact details may be shared with other government bodies for trade facilitation or business support purposes, e.g. Export Finance Australia and State/Territory Government trade facilitation agencies.</span>}
            preview={preview}
          />
        </div>

        <h4>Feedback agreement</h4>
        Austrade may contact applicants and grantees regarding feedback on the program. By checking the box below, you are indicating you would be happy to be contacted by the EMDG team to provide feedback.
        <div className="form-item">
          <Checkbox
            ref={(r) => { this.acceptFeedbackAgreement = r }}
            id="agreeFeedback"
            required={false}
            onChange={(val) => onChange({ acceptFeedbackAgreement: val || null })}
            value={model.acceptFeedbackAgreement}
            label={<span>I agree that the EMDG team may directly contact me to provide feedback on EMDG and my experiences with the program.</span>}
            preview={preview}
          />
        </div>

        {showTierSelectionSelection && (
          <>
            { preview && <h3>Tier selection and eligibility</h3>}
            <EMDGAccordion expanded header="Tier selection and eligibility">

                {preview ? (
                  <div className="form-item form-item-preview">
                    <span className="form-label">1. Which tier are you applying for? *</span>
                    <div className="form-value">
                        {(this.props.previewObj && this.props.previewObj.selectedTierDisplayName) || '--'}
                    </div>
                  </div>
                ) : (
                   <div className="form-item">
                      <div className="form-label" style={{ marginBottom: '20px' }}>
                        <span>
                            1. Which tier are you applying for?&nbsp;*
                            <br />
                            <span style={{ fontStyle: 'italic' }}>
                            See section 4.1 of the&nbsp;
                            <a href={`${GRANT_GUIDELINES_URL}`} target="_blank" rel="noreferrer">
                                Grant Guidelines
                            </a>
                            &nbsp;for more information on each tier.
                            </span>
                        </span>
                      </div>

                      {sortedData.map((item) => (
                          <div key={item.internalName} className="emdg-control-input" style={{ display: 'block', marginBottom: '5px' }}>
                              <input
                                type="radio"
                                id={`tier-${item.tierValue}`}
                                name="tier_radiobuttons"
                                value={item.tierValue}
                                onChange={this.tierSelection_ChangeHandler}
                                checked={selectedTierValue === item.tierValue.toString()}
                                className="emdg-control-input__input"
                              />
                              <label
                                className="emdg-control-input__text mb-0"
                                htmlFor={`tier-${item.tierValue}`}
                              >
                                  {item.displayName}
                              </label>
                          </div>
                      ))}

                      {isEligibleAsPerTierYearlyLimit === false && (
                          <Alert className="emdg-page-alerts emdg-page-alerts--error">
                          <div tabIndex={-1} ref={(r) => this.tierYearlyLimitEligibilityError = r}>
                              You are
                              {' '}
                              <b>not</b>
                              {' '}
                              eligible to apply for a grant with Austrade for this tier. Tier limits apply from Round 4. See section 4.1.1.5 of the
                              {' '}
                              <a target="_blank" href={`${GRANT_GUIDELINES_URL}`} rel="noreferrer">Grant Guidelines</a>
                              {' '}
                              for further information.
                          </div>
                          </Alert>
                      )}

                      {this.state.tierErrorMessage && (
                          <Alert className="emdg-page-alerts emdg-page-alerts--error">
                              <div dangerouslySetInnerHTML={{ __html: this.state.tierErrorMessage }} />
                          </Alert>
                      )}

                      {!model.isConsultant && grantHistoryEligibility && !grantHistoryEligibility.isEligible && (
                        <Alert className="emdg-page-alerts emdg-page-alerts--error">
                            <div tabIndex={-1} ref={(r) => this.grantHistoryEligibilityError = r} dangerouslySetInnerHTML={{ __html: grantHistoryEligibility.displayErrorMessage }} />
                        </Alert>
                      )}

                      {!model.isConsultant && anySubmittedApplicationExistsForAbn && (
                        <Alert className="emdg-page-alerts emdg-page-alerts--error">
                          <div tabIndex={-1} ref={(r) => this.abnError = r}>
                              {submittedApplicationExistsForAbnErrorMessage}
                          </div>
                        </Alert>
                      )}

                   </div>
                )}

              {showTierSelectedQuestions && (
                <>
                  <MultiSelectField
                    ref={(r) => { this.exportMarkets = r }}
                    id="export-markets"
                    label={tierSelectionInternalName === 'RepBody'
                      ? '2. Select up to 10 markets where you intend to promote your SME members\' eligible products.'
                      : '2. Select up to 10 markets where you intend to promote your eligible products.'}
                    description={(
                        <i>
                            Section 13 of the&nbsp;
                            <a href={`${GRANT_GUIDELINES_URL}`} target=" _blank" rel="noreferrer">Grant Guidelines</a>
                            &nbsp;defines a ‘market’ as a single economy. Eligible products are defined in section 5.2 of the&nbsp;
                            <a href={`${GRANT_GUIDELINES_URL}`} target=" _blank" rel="noreferrer">Grant Guidelines</a>.
                        </i>
                    )}
                    value={model.marketsCodes}
                    onChange={(marketsCodes) => onChange({ marketsCodes })}
                    dataSource={this.state.filteredMarkets}
                    maxCapacity={10}
                    required
                    position="relative"
                    preview={preview}
                    disabled={repBodyMarketsNotApplicable}
                  />
                    {tierSelectionInternalName === 'Tier1' && (
                      <Alert className="emdg-page-alerts">
                        If you plan to target more than 10 markets, please make note of it in the plan to market section of the application form.
                      </Alert>
                    )}
                    {tierSelectionInternalName === 'Tier2' && (
                      <Alert className="emdg-page-alerts">
                        You must intend to expand within your <b>existing</b> export markets and therefore you can only select your <b>existing</b> export markets from the list. You will be asked to confirm these markets, later in the application form.
                        <br /><br />
                        If you plan to target more than 10 markets, please make note of it in the plan to market section of the application form.
                      </Alert>
                    )}
                    {tierSelectionInternalName === 'Tier3' && (
                      <Alert className="emdg-page-alerts">
                        The <b>key</b> markets you select from the list must be <b>new</b> markets to your business, i.e. these markets cannot be markets that you currently export to. The new markets must also be key markets as identified in section 5.1 of the Grant Guidelines. You will be asked about export markets that you currently export to, later in the application form.
                        <br /><br />
                        If you plan to target more than 10 markets, please make note of it in the plan to market section of the application form.
                      </Alert>
                    )}
                    {tierSelectionInternalName === 'RepBody' && (
                      <>
                      <div className="form-item">
                         <div className="emdg-control-input emdg-control-input--block">
                            <input
                              className="emdg-control-input__input"
                              id="chkNotApplicableForRepBody"
                              type="checkbox"
                              checked={repBodyMarketsNotApplicable}
                              onChange={this.repBodyMarketsNotApplicable_CheckboxHandler}
                            />
                            <label className="emdg-control-input__text mb-0" htmlFor="chkNotApplicableForRepBody">
                              Not applicable
                            </label>
                         </div>
                      </div>

                      <Alert className="emdg-page-alerts">
                        If you are a Representative body who is only applying for EMDG to deliver or arrange the delivery of export training you can select &apos;Not applicable&apos;.
                        <br /><br />
                        If you plan to target more than 10 markets, please make note of it in the plan to market section of the application form.
                      </Alert>
                      </>
                    )}

                {model.isPeakIndustryBody === false
                  ? (
                    <>
                        <MoneyField
                          ref={(r) => { this.totalTurnover = r }}
                          id="totalTurnover"
                          label={`3. What was the annual turnover (i.e., your total annual income including sales) of your business for the last Australian financial year (${getLastFYForDisplay()})?`}
                          description={(
                            <i>
                                {'Refer to section 4.1.1 of the '}
                                <a href={`${GRANT_GUIDELINES_URL}`} target="_blank" rel="noreferrer">Grant Guidelines</a>
                                {' for more information on turnover requirements for each Tier.'}
                            </i>
                          )}
                          value={model.totalTurnover}
                          onChange={(totalTurnover) => onChange({ totalTurnover }, () => this.onTotalTurnoverChange())}
                          required
                          allowZero
                          block={false}
                          preview={preview}
                        />

                        <Alert className="emdg-page-alerts">
                            {`You will be asked to provide copies of your business’ profit and loss statement and balance sheet for the last two Australian financial years (${get2ndLastFYForDisplay()} and ${getLastFYForDisplay()}).`}
                            <br />
                            <br />
                            If your annual turnover is less than the amount required for your tier, or is greater than $20 million, you are
                            {' '}
                            <b>not</b>
                            {' '}
                            eligible to apply for a grant.
                        </Alert>

                        {annualTurnoverEligibility && annualTurnoverEligibility.isEligible && (
                            <Alert className="emdg-page-alerts">
                                Please upload your two financial years profit and loss statements and balance sheets.
                            </Alert>
                        )}
                        {annualTurnoverEligibility && !annualTurnoverEligibility.isEligible && (
                            <Alert className="emdg-page-alerts emdg-page-alerts--error">
                                <div tabIndex={-1} ref={(r) => this.annualTurnoverEligibilityError = r} dangerouslySetInnerHTML={{ __html: annualTurnoverEligibility.displayErrorMessage }} />
                            </Alert>
                        )}

                        <div className="form-item">
                            <BooleanRadioButtonField
                              ref={(r) => { this.enoughFundsForExpenditure = r }}
                              id="enoughFundsForExpenditure"
                              value={model.enoughFundsForExpenditure}
                              label="4. Do you have at least $20,000, per financial year, of your own funds to spend on eligible expenditure and can provide evidence to substantiate the minimum capacity to spend?"
                              description={(
                                <i>
                                    {'Refer to section 3.1.3 of the '}
                                    <a href={`${GRANT_GUIDELINES_URL}`} target="_blank" rel="noreferrer">Grant Guidelines</a>
                                    {' for more information.'}
                                </i>
                              )}
                              onChange={(enoughFundsForExpenditure) => onChange({ enoughFundsForExpenditure })}
                              dataSource={yesNoDataSource}
                              required
                              preview={preview}
                            />
                        </div>

                        {!model.enoughFundsForExpenditure && model.enoughFundsForExpenditure != null ? (
                            <Alert className="emdg-page-alerts emdg-page-alerts--error">
                                <div tabIndex={-1}>
                                    You are
                                    {' '}
                                    <b>not</b>
                                    {' '} eligible for a grant.
                                </div>
                            </Alert>
                        ) : null}
                        {model.enoughFundsForExpenditure && model.enoughFundsForExpenditure != null ? (
                            <Alert className="emdg-page-alerts">
                                <div tabIndex={-1}>
                                    You will be asked to provide further information and evidence in the Plan to market section of the application form.
                                </div>
                            </Alert>
                        ) : null}
                    </>
                  )
                  : null}
                </>
              )}
            </EMDGAccordion>
          </>
        )}

        {showApplicationBusinessDetails && (
          <div className="form-item">
            { preview && <h3>Applicant business details</h3>}
            <EMDGAccordion expanded header="Applicant business details">
              <AbnField
                ref={(r) => { this.abn = r }}
                id="abn"
                label="5. What is your Australian Business Number (ABN)?"
                description={(
                    <i>
                        {`${model.isConsultant
                          ? 'If your client is applying as a trustee on behalf of a trust, you need to provide the trust ABN in this section.'
                          : 'If you’re applying as a trustee on behalf of a trust, you need to provide the trust ABN in this section.'}`}
                    </i>
                )}
                value={formatDigits(model.abn)}
                onChange={() => { }} // Provide a no-op function
                onLostFocus={(abn, isValid) => this.ABN_LostFocus(abn, isValid)}
                required
                block={false}
                errorMessage={(model.abn && model.abnInvalid) ? 'Invalid or cancelled ABN' : null}
                maxLength={14}
                disabled={!model.isConsultant}
                preview={preview}
              />

              {previousInProgressApplication && (
                  <Alert className="emdg-page-alerts emdg-page-alerts--warning ">
                  Our system has identified that you have an existing application/pending grant agreement under a previous EMDG round.
                  Please note that EMDG applicants can only enter one EMDG Grant Agreement at a time. If you accept and execute one Grant Agreement,
                  we will deem the other pending Grant Agreement to be withdrawn.
                  <br />
                  <br />
                  Please note, this does not affect any ongoing appeals you may have lodged regarding an earlier grant agreement.
                  </Alert>
              )}

              {model.isConsultant && anySubmittedApplicationExistsForAbn && (
                  <Alert className="emdg-page-alerts emdg-page-alerts--error">
                  <div tabIndex={-1} ref={(r) => this.abnError = r}>
                      {submittedApplicationExistsForAbnErrorMessage}
                  </div>
                  </Alert>
              )}

              {activeGrantAgreement && (
                  <Alert className="emdg-page-alerts emdg-page-alerts--error">
                  <div tabIndex={-1} ref={(r) => this.abnError = r}>
                      You have an executed grant agreement and Grantees cannot apply for a new EMDG grant while there is more than one year remaining
                      until the Activity Completion Date. Please refer to Section C in your grant agreement.
                  </div>
                  </Alert>
              )}

              {model.isConsultant && grantHistoryEligibility && !grantHistoryEligibility.isEligible && (
                <Alert className="emdg-page-alerts emdg-page-alerts--error">
                    <div tabIndex={-1} ref={(r) => this.grantHistoryEligibilityError = r} dangerouslySetInnerHTML={{ __html: grantHistoryEligibility.displayErrorMessage }} />
                </Alert>
              )}

              <DateField
                ref={(r) => { this.dateOperationsCommenced = r }}
                id="businessCommenceDate"
                label="6. When did you commence your business operations under this ABN?"
                value={model.dateOperationsCommenced}
                onChange={(dateOperationsCommenced) => onChange({ dateOperationsCommenced }, () => this.onDateOperationsCommencedChange())}
                required
                preview={preview}
                errorMessage={new Date(model.dateOperationsCommenced) > new Date() ? 'A Future date cannot be entered' : null}
                max={new Date()}
              />

              {model.isPeakIndustryBody === false && (
                <Alert className="emdg-page-alerts">
                    The date here has been prefilled from the
                    {' '}
                    <a href={ABR_WEBSITE_URL} target="_blank" rel="noreferrer">ABR</a>
                    {' '}
                    website.
                    To be eligible to apply for a Tier 1, 2 and 3 grant, your minimum years in business under this ABN must be no less than 2 years from today’s date.
                    To check the date of your business registration, visit the
                    {' '}
                    <a href={ABR_WEBSITE_URL} target="_blank" rel="noreferrer">ABR</a>
                    {' '}
                    and
                    {' '}
                    <a href={ASIC_WEBSITE_URL} target="_blank" rel="noreferrer">ASIC</a>
                    {' '}
                    websites.
                </Alert>
              )}

              {yearsInBusinessEligibility && !yearsInBusinessEligibility.isEligible && (
                <Alert className="emdg-page-alerts emdg-page-alerts--error">
                    <div tabIndex={-1} ref={(r) => this.yearsInBusinessEligibilityError = r} dangerouslySetInnerHTML={{ __html: yearsInBusinessEligibility.displayErrorMessage }} />
                </Alert>
              )}

              <NumericSelectField
                ref={(r) => { this.businessCategory = r }}
                id="businessCategory"
                label="7. Select which type of eligible entity applies to you/your organisation:"
                value={model.businessCategory}
                onChange={(businessCategory) => onChange({ businessCategory })}
                dataSource={businessCategories}
                required
                preview={preview}
              />
              {model.businessCategory === BusinessCategoriesReform.Trust && (
                <Alert className="emdg-page-alerts">
                    If you are a trustee of a trust, you must provide the ACN of the trustee at Question 8 and upload a copy of the trust deed including all amendments with your online application.
                </Alert>
              )}
              <div tabIndex={-1} ref={(r) => { this.invalidBusinessCategoryError = r }} className="mt-2" style={{ display: this.isValidBusinessCategory() ? 'none' : '' }}>
                <Alert className="emdg-page-alerts emdg-page-alerts--error">
                    The business category that you have selected does not match the details in the Australian Business Register.
                    Please check that you are logging in with the correct ABN or have selected the correct entity type.
                </Alert>
              </div>

              {showACN && (
                <AcnField
                  ref={(r) => { this.acn = r }}
                  id="acn"
                  label="8. What is your Australian Company Number (ACN) if applicable?"
                  description={(
                    <i>
                        If you are applying as a trustee on behalf of a trust, this should be the ACN of the trustee.
                    </i>
                    )}
                  value={formatDigits(model.acn)}
                  onChange={(acn) => onChange({ acn: acn.replace(/ /g, '') })}
                  disabled={model.businessCategory !== BusinessCategoriesReform.Trust}
                  required={(model.businessCategory === BusinessCategoriesReform.BodyCorp && !!model.acn.replace(/\s+/g, ''))}
                  maxLength={11}
                  preview={preview}
                />
              )}

              <TextField
                ref={(r) => { this.registeredBusinessName = r }}
                id="registeredBusinessName"
                label="9. What is your registered legal entity name as per the Australian Business Register (ABR) record?"
                description={(
                <i>
                    If you are applying as a trustee on behalf of a trust, this should be the registered legal entity name of the trustee.
                </i>
                )}
                value={model.registeredBusinessName}
                onChange={(registeredBusinessName) => onChange({ registeredBusinessName })}
                required
                disabled
                maxLength={400}
                preview={preview}
              />

              <AnzicField
                ref={(r) => { this.anzsicCode = r }}
                id="anzsicCode"
                label="10. Provide your organisation’s ANZSIC code from the drop-down menu."
                value={model.anzsicCode}
                onChange={(anzsicCode) => onChange({ anzsicCode })}
                required
                preview={preview}
              />

              {preview ? (
                <div className="form-item form-item-preview">
                    <span className="form-label">11. Select the priority trade area (i.e. the industry sector) that may apply to your business.</span>
                    <div className="form-value">
                        {(this.props.previewObj && this.props.previewObj.priorityTradeAreaDisplayName) || '--'}
                    </div>
                </div>
              ) : (
                <NumericRadioButtonField
                  ref={(r) => { this.priorityTradeArea = r }}
                  id="priorityTradeAreaID"
                  label="11. Select the priority trade area (i.e. the industry sector) that may apply to your business."
                  value={model.priorityTradeArea}
                  onChange={(priorityTradeArea) => onChange({ priorityTradeArea })}
                  dataSource={this.state.priorityTradeAreaDataSource}
                  block
                  required
                  preview={preview}
                  layout={LayoutDisplayEnum.Vertical} // Specify the layout here
                />
              )}

              <TextField
                ref={(r) => { this.tradingName = r }}
                id="tradingName"
                label="12. What is your business or entity name (if different to the registered business name)?"
                description={(
                <i>
                    If you are applying as a trustee on behalf of a trust, this should be the business or entity name of the trustee.
                </i>
                )}
                value={model.tradingName}
                maxLength={80}
                onChange={(tradingName) => onChange({ tradingName })}
                preview={preview}
              />

              <BooleanRadioButtonField
                ref={(r) => { this.hasBusinessNameChanged = r }}
                id="hasBusinessNameChanged"
                value={model.hasBusinessNameChanged}
                label={(
                <>
                    {'13. Did your business have an alternative name that is not listed on the ABR register or '}
                    <a href={`https://abr.business.gov.au/AbnHistory/View?id=${model.abn}`} target="_blank" rel="noreferrer">business name history</a>
                    ?
                </>
                )}
                onChange={(hasBusinessNameChanged) => onChange({ hasBusinessNameChanged })}
                dataSource={yesNoDataSource}
                required
                preview={preview}
              />

              {model.hasBusinessNameChanged && (
                  <>
                      <DateField
                        ref={(r) => { this.dateBusinessNameChanged = r }}
                        id="dateBusinessNameChanged"
                        label="14. When did you change your business name?"
                        value={model.dateBusinessNameChanged}
                        onChange={(dateBusinessNameChanged) => onChange({ dateBusinessNameChanged })}
                        required={model.hasBusinessNameChanged}
                        preview={preview}
                        errorMessage={new Date(model.dateBusinessNameChanged) > new Date() ? 'A Future date cannot be entered' : null}
                        max={new Date()}
                      />

                      <TextField
                        ref={(r) => { this.previousBusinessName = r }}
                        id="tradingNameChangedFrom"
                        label="15. What was the previous business name?"
                        value={model.previousBusinessName}
                        maxLength={400}
                        onChange={(previousBusinessName) => onChange({ previousBusinessName })}
                        required={model.hasBusinessNameChanged}
                        preview={preview}
                      />
                  </>
              )}

              {!model.isPeakIndustryBody
                  && (
                  <div className="form-item">
                    <Label
                      label="16. Prior Grants"
                      preview={preview}
                    />
                    <PriorGrants model={model} onChange={onChange} preview={preview} />
                  </div>
                  )}

              <BooleanRadioButtonField
                ref={(r) => { this.acceptATOComplianceDeclaration = r }}
                id="isATOComplianceAccepted"
                label="17. At the time of applying, I declare that during the current income year and the previous two income years I have been compliant with all the relevant Australian Taxation Office (ATO) legislation, rulings and guidelines."
                value={model.acceptATOComplianceDeclaration}
                onChange={(acceptATOComplianceDeclaration) => onChange({ acceptATOComplianceDeclaration })}
                dataSource={yesNoDataSource}
                required
                preview={preview}
              />

              {model.acceptATOComplianceDeclaration && (
                <Alert className="emdg-page-alerts">
                    {`To prove your compliance, you are required to upload one of the following documents for the previous two financial years (${get2ndLastFYForDisplay()} and ${getLastFYForDisplay()}):`}
                    <ul>
                        <li>Business Activity Statement</li>
                        <li>Notice of Assessment</li>
                        <li>Statements of Account</li>
                        <li>Details of your payment plan (if you are currently on an ATO payment plan)</li>
                    </ul>
                </Alert>
              )}

              {model.acceptATOComplianceDeclaration === false && (
                    <Alert className="emdg-page-alerts emdg-page-alerts--error">
                        <div tabIndex={-1} ref={(r) => this.ATOComplianceDeclarationError = r}>
                            This is a declaration that you have not complied with your obligations under taxation laws as per Rule 13 (1) of the EMDG Rules.
                            <br />
                            <br />
                            You are
                            {' '}
                            <b>not</b>
                            {' '}
                            eligible to apply for a grant if you or any associate/s of the applicant business is not compliant with all relevant Australian Taxation Office (ATO) legislation, rulings and guidelines.
                        </div>
                    </Alert>
              )}

              {model.isPeakIndustryBody === false && (
                <BooleanRadioButtonField
                  ref={(r) => { this.isInsolvent = r }}
                  id="isInsolvent"
                  label="18. Are you currently under insolvency administration?"
                  description={(
                    <i>
                        If the application is on behalf of a trust, the response must be for the trustee of the trust.
                    </i>
                  )}
                  value={model.isInsolvent}
                  onChange={(isInsolvent) => onChange({ isInsolvent })}
                  dataSource={yesNoDataSource}
                  required={model.isPeakIndustryBody === false}
                  preview={preview}
                />
              )}

                {model.isInsolvent && !model.isPeakIndustryBody && (
                    <Alert className="emdg-page-alerts emdg-page-alerts--error">
                        <div tabIndex={-1} ref={(r) => this.insolvenyError = r}>
                            This is a declaration that you are currently under insolvency administration or, if the application is on behalf of a trust, that the trustee of the trust is under insolvency administration.
                            <br />
                            <br />
                            You are
                            {' '}
                            <b>not</b>
                            {' '}
                            eligible to apply for a grant if you or any associate/s of the applicant business is subject to insolvency administration.
                        </div>
                    </Alert>
                )}

              <BooleanRadioButtonField
                ref={(r) => { this.isConvictedDisqualified = r }}
                id="isConvictedDisqualified"
                label="19. Have you had any outstanding disqualifying convictions?"
                value={model.isConvictedDisqualified}
                onChange={(isConvictedDisqualified) => onChange({ isConvictedDisqualified })}
                dataSource={yesNoDataSource}
                required
                preview={preview}
              />

                {model.isConvictedDisqualified && (
                    <Alert className="emdg-page-alerts emdg-page-alerts--error">
                        <div tabIndex={-1} ref={(r) => this.convictedDisqualificationError = r}>
                            This is a declaration that you have one or more outstanding disqualifying convictions as per Rule 13 (4) of the (EMDG Rules).
                            <br />
                            <br />
                            You are
                            {' '}
                            <b>not</b>
                            {' '}
                            eligible to apply for a grant if you or any associate/s of the applicant business has any outstanding disqualifying convictions.
                        </div>
                    </Alert>
                )}

                <NumberField
                  ref={(r) => { this.totalEmployees = r }}
                  id="totalEmployeesAustralia"
                  label={`20. What is the total number of Australian-based employees of your business as at the end of the last Australian financial year (${getLastFYForDisplay()})?`}
                  description={(
                    <i>
                        Include all full and part time employees, contractors and working directors based overseas.
                    </i>
                  )}
                  value={model.totalEmployees}
                  onChange={(totalEmployees) => onChange({ totalEmployees })}
                  required
                  min={1}
                  max={20000}
                  maxMessage="The number of employees reported is extremely high for a SME business."
                  wholeNumbersOnly
                  block={false}
                  preview={preview}
                />

                <NumberField
                  ref={(r) => { this.totalEmployeesOverseas = r }}
                  id="totalEmployeesOverseas"
                  label={`21. What is the total number of overseas-based employees of your business as at the end of the last Australian financial year (${getLastFYForDisplay()})?`}
                  description={(
                    <i>
                        Include all full and part time employees, contractors and working directors based overseas.
                    </i>
                  )}
                  value={model.totalEmployeesOverseas}
                  onChange={(totalEmployeesOverseas) => onChange({ totalEmployeesOverseas })}
                  required
                  min={0}
                  max={20000}
                  maxMessage="The number of employees reported is extremely high for a SME business."
                  wholeNumbersOnly
                  block={false}
                  preview={preview}
                />
            </EMDGAccordion>
          </div>
        )}

            {showApplicationBusinessStructure && (
                <div className="form-item">
                    {preview && <h3>Applicant business structure</h3>}
                    <EMDGAccordion header="Applicant business structure" expanded>

                    <BooleanRadioButtonField
                      ref={(r) => { this.partOfRelatedGroup = r }}
                      id="partOfRelatedGroup"
                      label={`22. Were you part of a group of related companies as at the end of the last Australian financial year (${getLastFYForDisplay()})?`}
                      value={model.partOfRelatedGroup}
                      onChange={(partOfRelatedGroup) => onChange({ partOfRelatedGroup })}
                      dataSource={yesNoDataSource}
                      required
                      preview={preview}
                    />

                    {model.partOfRelatedGroup && (
                        <>
                        <Alert className="emdg-page-alerts">
                            Include all holding companies and all subsidiaries, as well as overseas registered companies in that corporate group.
                            Enter this information in the provided fields.
                            Please note there is no upload functionality for this question.
                        </Alert>

                  <Table<RelatedCompanyModel>
                    ref={(r) => { this.relatedCompanies = r }}
                    header={(
                          <Button
                            id="btnAddRelationship"
                            className="emdg-btn prepare-btn"
                            onClick={async () => {
                              await this.savePriorToNewRoute();
                              history.push(`/reform/${model.applicationID}/applicant/relatedCompanies`)
                            }}
                          >
                            Add/Edit
                          </Button>
                        )}
                    label="Related companies"
                    id="relationships"
                    value={model.relatedCompanies}
                    onChange={(relatedCompanies) => onChange({ relatedCompanies })}
                    columns={relatedCompanyColumns}
                    renderSection={(p) => <RelatedCompanyDetails {...p} preview application={model} addressCountries={addressCountries} />}
                    required={model.partOfRelatedGroup}
                    alwaysShowAllRows
                    preview={preview}
                  />
                        </>
                    )}

              {model.isPeakIndustryBody === false && (
                  <BooleanRadioButtonField
                    ref={(r) => { this.hasCompanyHistory = r }}
                    id="hasCompanyHistory"
                    label="23. Are you carrying on a business, or have you bought a business or a part of a business,
                      or acquired significant assets from any other person/business that has or may have received an EMDG grant?"
                    value={model.hasCompanyHistory}
                    onChange={(hasCompanyHistory) => onChange({ hasCompanyHistory })}
                    dataSource={yesNoDataSource}
                    required={model.isPeakIndustryBody === false}
                    preview={preview}
                  />
              )}

              {model.hasCompanyHistory && !model.isPeakIndustryBody && (
                  <>
                  <Alert className="emdg-page-alerts emdg-page-alerts--warning">
                      In accordance with Rule 13 and Rule 48 (Export Market Development Grants Rules 2021),
                      Austrade will not pay a grant in respect of more than 8 financial years and/or when total grants exceeds $770,000.
                      All grants paid at any time on or after 1 July 1990 are included in this calculation.
                      Please note that grants paid to other persons may be attributed to this applicant
                      if Austrade is satisfied that the grantee is in substance conducting the same business as the previous business.
                  </Alert>

                  Provide the name of the previous business and ABN, if known.
                  <Table<CompanyHistoryModel>
                    ref={(r) => { this.companyHistories = r }}
                    header={(
                      <Button
                        id="btnAddCompanyHistory"
                        className="emdg-btn prepare-btn"
                        onClick={async () => {
                          await this.savePriorToNewRoute();
                          history.push(`/reform/${model.applicationID}/applicant/companyhistories`)
                        }}
                      >
                          Add/Edit
                      </Button>
                      )}
                    label="Company Histories"
                    id="companyHistory"
                    value={model.companyHistories}
                    onChange={(companyHistories) => onChange({ companyHistories })}
                    columns={companyHistoryColumns}
                    renderSection={(p) => <CompanyHistoryDetails {...p} />}
                    alwaysShowAllRows
                    additionalTableClasses="additional-header"
                    preview={preview}
                    required={model.hasCompanyHistory}
                  />

                  </>
              )}

                    {showBusinessDirectory
                        && (
                        <>
                            <Label
                              label={`24. Provide names of all company directors or partners in the partnership during the last Australian financial year (${getLastFYForDisplay()}). *`}
                              preview={preview}
                            />
                            <Table<BusinessPartnerModel>
                              ref={(r) => { this.businessPartners = r }}
                              header={(
                                <Button
                                  id="btnAddBusinessPartner"
                                  className="emdg-btn prepare-btn"
                                  onClick={async () => {
                                    await this.savePriorToNewRoute();
                                    history.push(`/reform/${model.applicationID}/applicant/BusinessPartners`)
                                  }}
                                >
                                Add/Edit
                                </Button>
                            )}
                              label="Directors or partners in the partnership"
                              id="businessPartner"
                              value={model.businessPartners}
                              onChange={(businessPartners) => onChange({ businessPartners })}
                              columns={businessPartnerColumns}
                              renderSection={(p) => <BusinessPartnerDetails {...p} />}
                              alwaysShowAllRows
                              required
                              additionalTableClasses="additional-header"
                              preview={preview}
                            />
                        </>
                        )}

                    <BooleanRadioButtonField
                      ref={(r) => { this.directorInBusinessPreviouslyAppliedForGrant = r }}
                      id="directorInBusinessPreviouslyAppliedForGrant"
                      label={`25. Have any of the directors or partners that were recorded as office holders during the last Australian financial year (${getLastFYForDisplay()}), ever been involved with any other businesses that has previously applied for an EMDG grant?`}
                      value={model.haveYourBusinessPartnersEverAppliedEMDG}
                      onChange={(haveYourBusinessPartnersEverAppliedEMDG) => onChange({ haveYourBusinessPartnersEverAppliedEMDG })}
                      dataSource={yesNoDataSource}
                      required
                      preview={preview}
                    />

                {model.haveYourBusinessPartnersEverAppliedEMDG && (
                    <>
                    <TextField
                      ref={(r) => { this.directorCompanyName = r }}
                      id="directorCompanyName"
                      label="25.a. What is the company name?"
                      value={model.directorCompanyName}
                      maxLength={80}
                      onChange={(directorCompanyName) => onChange({ directorCompanyName })}
                      preview={preview}
                      required={model.haveYourBusinessPartnersEverAppliedEMDG && ((!model.directorCompanyName && !directorABN) || !!model.directorCompanyName)}
                    />
                    <AbnField
                      ref={(r) => { this.directorABN = r }}
                      id="directorABN"
                      label="25.b. What is the ABN?"
                      value={formatDigits(directorABN)}
                      onChange={(abn) => onChange({ directorABN: abn.replace(/ /g, '') })}
                      required={model.haveYourBusinessPartnersEverAppliedEMDG && ((!model.directorCompanyName && !directorABN) || !!directorABN)}
                      block={false}
                      maxLength={14}
                      preview={preview}
                    />
                    </>
                )}

                    <h3>First Nations organisation</h3>
                    <NumericRadioButtonField
                      ref={(r) => { this.isIndiginousOwned = r }}
                      id="indigenousOwned"
                      label="26. Is your organisation First Nations owned?"
                      value={model.isIndiginousOwned}
                      onChange={(isIndiginousOwned) => onChange({ isIndiginousOwned })}
                      dataSource={yesNoPreferNotSayDataSourceEx}
                      required
                      preview={preview}
                    />
                    {model.isIndiginousOwned === YesNoPrefer.Yes && (
                        <Alert className="emdg-page-alerts">
                            An organisation is considered a First Nations organisation if it is at least 51% owned by an Aboriginal person(s) and/or a Torres Strait Islander person(s).
                            <br />
                            <br />
                            Please note that promotion, sale and/or export of First Nations-created eligible products does not immediately qualify an organisation as First Nations owned.
                        </Alert>
                    )}

                    <NumericRadioButtonField
                      ref={(r) => { this.isIndiginousControlled = r }}
                      id="isIndiginousControlled"
                      label="27. Is your organisation First Nations controlled?"
                      value={model.isIndiginousControlled}
                      onChange={(isIndiginousControlled) => onChange({ isIndiginousControlled })}
                      dataSource={yesNoPreferNotSayDataSourceEx}
                      required
                      preview={preview}
                    />
                    {model.isIndiginousControlled === YesNoPrefer.Yes && (
                        <Alert className="emdg-page-alerts">
                            An organisation is considered First Nations controlled where at least 51% of the organisation’s board or management committee is Indigenous.
                            <br />
                            <br />
                            Austrade may contact you for a specific case study to raise awareness of EMDG to other Indigenous organisations.
                            <br />
                            <br />
                            Please note that promotion, sale and/or export of First Nations-created eligible products does not immediately qualify an organisation as First Nations controlled.
                        </Alert>
                    )}

                {(model.isIndiginousOwned === YesNoPrefer.Yes || model.isIndiginousControlled === YesNoPrefer.Yes) && (
                  <>
                  <div className="form-item">
                    <Label
                      label="28."
                      preview={preview}
                    />
                    <Checkbox
                      id="consentShareFirstNationsInfo"
                      required={false}
                      onChange={(val) => onChange({ hasConsentedToShareFirstNationsStatus: val })}
                      value={model.hasConsentedToShareFirstNationsStatus}
                      label={<span>I consent for Austrade to share my First Nations organisation status with other government organisations.</span>}
                      preview={preview}
                    />
                  </div>

                  {model.hasConsentedToShareFirstNationsStatus && (
                    <Alert className="emdg-page-alerts">
                        I agree that my contact details and First Nations status may be shared with other government bodies for trade facilitation or business support purposes, e.g., Export Finance Australia, the Department of Foreign Affairs and Trade or other government agencies.
                    </Alert>
                  )}
                  </>
                )}
                    </EMDGAccordion>
                </div>
            )}

        <NextBackButtons
          onBack={() => {
            if (confirm('Changes you made may not be saved.')) {
              history.goBack()
            }
          }}
          onNext={this.next}
          nextDisabled={!!this.state.tierErrorMessage || !this.state.tierSelectionIsValid}
          preview={preview}
        />
        <Backdrop on={loading} />
      </>
    )
  }
}
